import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M18.292 7.363H9.709v3.476h4.94c-.46 2.21-2.385 3.479-4.94 3.479-3.013 0-5.442-2.373-5.442-5.319 0-2.945 2.429-5.318 5.442-5.318a5.4 5.4 0 0 1 3.39 1.187l2.68-2.619C14.148.86 12.055 0 9.71 0 4.602 0 .5 4.008.5 9s4.101 9 9.209 9c4.604 0 8.791-3.273 8.791-9a7.36 7.36 0 0 0-.208-1.637Z"
    />
  </svg>
);
export default SvgGoogle;
